import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

interface IToastMessage {
	isOpen: boolean;
	onClose: () => void;
	onAlertClose: () => void;
	message: string;
	variant?: "error" | "dark";
}
const ToastMessage = ({ variant = "error", ...props }: IToastMessage) => {
	const variantStyle =
		variant === "dark"
			? { color: "#FFFFFF", background: "rgba(28, 49, 69, 0.90)", borderRadius: "4px" }
			: { color: "#762400", background: "#FEF2F1", borderRadius: "12px" };

	return (
		<Snackbar
			open={props.isOpen}
			autoHideDuration={5000}
			onClose={props.onClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			style={{ maxWidth: "640px" }}
		>
			<Alert
				icon={variant === "dark" ? false : undefined}
				onClose={props.onAlertClose}
				severity="error"
				variant="filled"
				style={variantStyle}
			>
				{props.message}
			</Alert>
		</Snackbar>
	);
};

export default ToastMessage;
